export default {
  PROCESSING_PERCENTAGE: 0.0125,
};
